import { render } from "./sfAIFastFoodDetail.vue?vue&type=template&id=839369e8"
import script from "./sfAIFastFoodDetail.vue?vue&type=script&lang=js"
export * from "./sfAIFastFoodDetail.vue?vue&type=script&lang=js"

import "./sfAIFastFoodDetail.vue?vue&type=style&index=0&id=839369e8&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__